import * as moment from 'moment';
import * as angular from 'angular';

import {
  Input,
  Inject,
  OnInit,
  Component,
} from 'ng-metadata/core';

import { ProductService } from 'services/product.service';
import { VisaProcessingService } from 'components/visa-processing/visa-processing.service';

import productRequirementsHtml from './product-requirements.html';
import './product-requirements.scss';



/**
 * Product Requirements form component class.
 */
@Component({
  selector: 'gw-product-requirements',
  template: productRequirementsHtml,
  legacy: {
    transclude: true,
  },
})
export class ProductRequirementsComponent implements OnInit {
  public state: any = {
    loading: false,
    traveler: null,
  };
  public product;
  public travelers = [];
  public requirements = [];

  @Input() type: string
  @Input() subtype: string
  @Input() country: string
  @Input() heading: string;

  constructor(
    @Inject('$rootScope') private $rootScope: ng.IRootScopeService,
    @Inject(ProductService) private productService: ProductService,
    @Inject(VisaProcessingService) private visaProcessingService: VisaProcessingService,
  ) {}

  /**
   * Component init
   */
  ngOnInit() {
    this.travelers = this.visaProcessingService.travelers;

    this.$rootScope.$on('gw-refresh-requirements', (e: ng.IAngularEvent, data) => {
      this.getRequirements(data);
    });
  }

  async getRequirements(traveler) {
    this.state.loading = true;

    this.state.country = traveler.country;
    this.state.citizenship = traveler.citizenship;

    let data = {
      citizenship: traveler.citizenship,
      residency: traveler.residency,
      country: this.country,
      subtype: this.subtype,
      type: this.type
    }

    try {
      this.product = await this.productService.getRequirements(data);
    } catch (e) {
      throw e;
    } finally {
      this.state.loading = false;
    }
  }

  showTravelerSelect() {
    const i = this.travelers.findIndex((traveler) => {
      return !traveler.name;
    });

    return (this.travelers.length > 1) && (i === -1);
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/product-requirements/product-requirements.component.ts